var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _radialGradient21, _radialGradient22, _radialGradient23, _radialGradient24, _radialGradient25, _radialGradient26, _radialGradient27, _radialGradient28, _radialGradient29, _radialGradient30, _radialGradient31, _radialGradient32, _radialGradient33, _radialGradient34, _mask, _mask2, _mask3, _mask4, _mask5, _mask6, _mask7, _mask8, _mask9, _mask10, _mask11, _mask12, _mask13, _mask14, _mask15, _mask16, _linearGradient, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetherlandsLotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-70 0 1000 510",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59 143.89a51.65 51.65 0 0 0 27.84 50.48 85.78 85.78 0 0 0 30.4.06 85 85 0 0 0 33-13.08A51.64 51.64 0 0 0 59.56 97l-4.6-.2a51.64 51.64 0 0 0-51.37 47.1",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 142.23a37.1 37.1 0 1 0 57-45.12 52.81 52.81 0 0 0-5.75-.32 51.65 51.65 0 0 0-51.25 45.44",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.46 122.69a60.4 60.4 0 1 0 92.86-73.47 84.13 84.13 0 0 0-92.86 73.47",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.15 132.5c0 31.24 12.33 57.86 29.6 68a84.09 84.09 0 0 0-.42-135.79c-17.05 10.34-29.18 36.78-29.18 67.76",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.43 148.25c0 19.19 7.57 35.54 18.18 41.78a51.65 51.65 0 0 0-.25-83.4c-10.48 6.35-17.93 22.6-17.93 41.62",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.75 138.58A60.76 60.76 0 0 0 117.51 198a101.09 101.09 0 0 0 35.76.07 100 100 0 0 0 38.8-15.4 60.76 60.76 0 0 0-41.47-99.28l-5.4-.22a60.75 60.75 0 0 0-60.44 55.4",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 136.63a43.63 43.63 0 1 0 67.1-53.09A60.85 60.85 0 0 0 85 136.63",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.67 143.71c0 22.57 8.91 41.8 21.4 49.15a60.76 60.76 0 0 0-.31-98.11c-12.32 7.47-21.09 26.57-21.09 49",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.82 132.23a71.51 71.51 0 0 0 38.53 69.87 120.92 120.92 0 0 0 87.73-18 71.47 71.47 0 0 0-48.79-116.78l-6.36-.28a71.49 71.49 0 0 0-71.11 65.19",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.05 129.93A51.34 51.34 0 1 0 258 67.48a73.26 73.26 0 0 0-8-.44 71.48 71.48 0 0 0-71 62.89",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267 138.27c0 26.55 10.48 49.18 25.17 57.82a71.49 71.49 0 0 0-.37-115.43c-14.5 8.8-24.8 31.27-24.8 57.6",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-92.5-58H917.16v624.3H-92.5z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-92.5-58H917.15v624.3H-92.5z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.47 193.16h82.41v8.67H18.47z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59 143.89a51.63 51.63 0 1 0 56-46.9l-4.6-.2a51.64 51.64 0 0 0-51.37 47.1",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59 143.89a51.65 51.65 0 0 0 27.84 50.48 85.78 85.78 0 0 0 30.4.06 85 85 0 0 0 33-13.08A51.64 51.64 0 0 0 59.56 97l-4.6-.2a51.64 51.64 0 0 0-51.37 47.1",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 142.23a37.1 37.1 0 1 0 57-45.12 52.81 52.81 0 0 0-5.75-.32 51.65 51.65 0 0 0-51.25 45.44",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.43 148.25c0 19.19 7.57 35.54 18.18 41.78a51.65 51.65 0 0 0-.25-83.4c-10.48 6.35-17.93 22.6-17.93 41.62",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.56 196.78h96.96v10.2h-96.96z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.75 138.58A60.75 60.75 0 1 0 150.6 83.4l-5.4-.23a60.75 60.75 0 0 0-60.44 55.4",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.75 138.58A60.76 60.76 0 0 0 117.51 198a101.09 101.09 0 0 0 35.76.07 100 100 0 0 0 38.8-15.4 60.76 60.76 0 0 0-41.47-99.28l-5.4-.22a60.75 60.75 0 0 0-60.44 55.4",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 136.63a43.63 43.63 0 1 0 67.1-53.09A60.85 60.85 0 0 0 85 136.63",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.67 143.71c0 22.57 8.91 41.8 21.4 49.15a60.76 60.76 0 0 0-.31-98.11c-12.32 7.47-21.09 26.57-21.09 49",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.92 200.54h115.26v12.12H200.92z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.82 132.23a71.47 71.47 0 1 0 77.48-64.91l-6.36-.28a71.49 71.49 0 0 0-71.11 65.19",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.82 132.23a71.51 71.51 0 0 0 38.53 69.87 120.92 120.92 0 0 0 87.73-18 71.47 71.47 0 0 0-48.79-116.78l-6.36-.28a71.49 71.49 0 0 0-71.11 65.19",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.05 129.93A51.34 51.34 0 1 0 258 67.48a73.26 73.26 0 0 0-8-.44 71.48 71.48 0 0 0-71 62.89",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267 138.27c0 26.55 10.48 49.18 25.17 57.82a71.49 71.49 0 0 0-.37-115.43c-14.5 8.8-24.8 31.27-24.8 57.6",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.6 205h137v14.4h-137z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.19 125.39A84.08 84.08 0 1 0 382.33 49q-3.74-.33-7.48-.33a84.09 84.09 0 0 0-83.66 76.7",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.19 125.39a84.09 84.09 0 0 0 45.33 82.2 140 140 0 0 0 49.5.1 138.42 138.42 0 0 0 53.7-21.3A84.08 84.08 0 0 0 382.32 49l-7.47-.34a84.09 84.09 0 0 0-83.66 76.7",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.46 122.69a60.4 60.4 0 1 0 92.86-73.47 84.13 84.13 0 0 0-92.86 73.47",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.15 132.5c0 31.24 12.33 57.86 29.6 68a84.09 84.09 0 0 0-.42-135.79c-17.05 10.34-29.18 36.78-29.18 67.76",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.54 210.55h162.81v17.12H452.54z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424 116.69a98.92 98.92 0 1 0 107.2-89.84l-8.8-.4a99 99 0 0 0-98.4 90.24",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424 116.69a98.94 98.94 0 0 0 53.33 96.7 164.68 164.68 0 0 0 58.24.12 162.84 162.84 0 0 0 63.18-25.06 98.93 98.93 0 0 0-67.55-161.6l-8.8-.4a99 99 0 0 0-98.4 90.24",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.3 113.5a71.05 71.05 0 1 0 109.24-86.44 101.63 101.63 0 0 0-11-.6 98.93 98.93 0 0 0-98.21 87.05",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546.27 125.05c0 36.75 14.51 68.07 34.84 80a98.94 98.94 0 0 0-.5-159.75c-20.07 12.17-34.34 43.27-34.34 79.73",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M613.62 217.21h193.49v20.36H613.62z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.06 117.46A116.37 116.37 0 1 0 698.43 1.09a116.37 116.37 0 0 0-116.37 116.37",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.68 110.28A103.28 103.28 0 1 0 690 7a103.28 103.28 0 0 0-103.32 103.28",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.5 107.23A116.38 116.38 0 1 0 708.65 1.54q-5.16-.47-10.35-.46a116.39 116.39 0 0 0-115.8 106.15",
    style: {
      fill: "none"
    }
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 356.14,
    cy: -357.65,
    r: 1,
    gradientTransform: "matrix(61.73 -10.74 8.53 49.04 -18880.8 21504.73)",
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 349.51,
    cy: -358.64,
    r: 1,
    gradientTransform: "translate(-12206.09 12688.08) scale(35.03)",
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: 354.52,
    cy: -355.42,
    gradientTransform: "translate(-19876.08 20368.05) scale(57.04)",
    xlinkHref: "#b"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 349.78,
    cy: -355.39,
    r: 1,
    gradientTransform: "matrix(35.78 0 0 57.41 -12072.35 20538.63)",
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 341.79,
    cy: -358.58,
    gradientTransform: "matrix(21.97 0 0 35.26 -7413.59 12792.84)",
    xlinkHref: "#c"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 357.1,
    cy: -356.54,
    gradientTransform: "matrix(72.63 -12.64 10.04 57.7 -22212.49 25217.44)",
    xlinkHref: "#d"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 351.46,
    cy: -357.39,
    gradientTransform: "translate(-14359.85 14844.92) scale(41.21)",
    xlinkHref: "#b"
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 344.9,
    cy: -357.34,
    gradientTransform: "matrix(25.85 0 0 41.48 -8721.83 14968.16)",
    xlinkHref: "#c"
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 357.91,
    cy: -355.61,
    gradientTransform: "matrix(85.44 -14.87 11.81 67.88 -26133.5 29585.22)",
    xlinkHref: "#d"
  })), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 353.12,
    cy: -356.32,
    gradientTransform: "translate(-16895.14 17382.27) scale(48.48)",
    xlinkHref: "#b"
  })), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 347.54,
    cy: -356.28,
    gradientTransform: "matrix(30.41 0 0 48.8 -10262.16 17527.26)",
    xlinkHref: "#c"
  })), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 358.08,
    cy: -347.28,
    r: 1,
    gradientTransform: "rotate(67.04 -8457.722 -44734.77) scale(100.96)",
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffec00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ffec00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fce600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f0ce00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e9bf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e7ba00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffde00"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 356.14,
    cy: -357.65,
    r: 1,
    gradientTransform: "matrix(61.73 -10.74 8.53 49.04 -18880.8 21504.73)",
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffec00"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 349.51,
    cy: -358.64,
    r: 1,
    gradientTransform: "translate(-12206.09 12688.08) scale(35.03)",
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffef4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffef4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fff056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff164"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 341.79,
    cy: -358.58,
    r: 1,
    gradientTransform: "matrix(21.97 0 0 35.26 -7413.59 12792.84)",
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5b100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#e9b400"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "N",
    cx: 358.74,
    cy: -347.73,
    gradientTransform: "rotate(67.04 -9887.343 -52670.324) scale(118.78)",
    xlinkHref: "#e"
  })), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Q",
    cx: 357.1,
    cy: -356.54,
    gradientTransform: "matrix(72.63 -12.64 10.04 57.7 -22212.49 25217.44)",
    xlinkHref: "#f"
  })), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "T",
    cx: 351.46,
    cy: -357.39,
    gradientTransform: "translate(-14359.85 14844.92) scale(41.21)",
    xlinkHref: "#g"
  })), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "W",
    cx: 344.9,
    cy: -357.34,
    gradientTransform: "matrix(25.85 0 0 41.48 -8721.83 14968.16)",
    xlinkHref: "#h"
  })), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Z",
    cx: 359.31,
    cy: -348.12,
    gradientTransform: "rotate(67.04 -11570.108 -62006.09) scale(139.74)",
    xlinkHref: "#e"
  })), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ac",
    cx: 357.91,
    cy: -355.61,
    gradientTransform: "matrix(85.44 -14.87 11.81 67.88 -26133.5 29585.22)",
    xlinkHref: "#f"
  })), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "af",
    cx: 353.12,
    cy: -356.32,
    gradientTransform: "translate(-16895.14 17382.27) scale(48.48)",
    xlinkHref: "#g"
  })), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ai",
    cx: 347.54,
    cy: -356.28,
    gradientTransform: "matrix(30.41 0 0 48.8 -10262.16 17527.26)",
    xlinkHref: "#h"
  })), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "al",
    cx: 359.78,
    cy: -348.44,
    gradientTransform: "rotate(67.039 -13550.341 -72992.45) scale(164.4)",
    xlinkHref: "#e"
  })), _radialGradient25 || (_radialGradient25 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ao",
    cx: 358.6,
    cy: -354.81,
    gradientTransform: "matrix(100.52 -17.49 13.9 79.86 -30744.79 34724.49)",
    xlinkHref: "#f"
  })), _radialGradient26 || (_radialGradient26 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ar",
    cx: 354.52,
    cy: -355.42,
    gradientTransform: "translate(-19876.08 20368.06) scale(57.04)",
    xlinkHref: "#g"
  })), _radialGradient27 || (_radialGradient27 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "au",
    cx: 349.78,
    cy: -355.39,
    gradientTransform: "matrix(35.78 0 0 57.41 -12072.35 20538.63)",
    xlinkHref: "#h"
  })), _radialGradient28 || (_radialGradient28 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ax",
    cx: 360.19,
    cy: -348.72,
    gradientTransform: "rotate(67.038 -15877.173 -85910.02) scale(193.4)",
    xlinkHref: "#e"
  })), _radialGradient29 || (_radialGradient29 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "aA",
    cx: 359.18,
    cy: -354.13,
    gradientTransform: "matrix(118.26 -20.58 16.35 93.95 -36169.21 40769.94)",
    xlinkHref: "#f"
  })), _radialGradient30 || (_radialGradient30 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "aD",
    cx: 355.72,
    cy: -354.65,
    gradientTransform: "matrix(67.1 0 0 67.1 -23382.54 23880.11)",
    xlinkHref: "#g"
  })), _radialGradient31 || (_radialGradient31 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "aG",
    cx: 351.69,
    cy: -354.62,
    gradientTransform: "matrix(42.1 0 0 67.54 -14201.67 24080.75)",
    xlinkHref: "#h"
  })), _radialGradient32 || (_radialGradient32 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "aJ",
    cx: 360.5,
    cy: -349.18,
    r: 1,
    gradientTransform: "rotate(62 -25689.481 -111166.87) scale(235.42)",
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffec00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ffec00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#f8db00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f0c800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ecbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#eab900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "gold"
  }))), _radialGradient33 || (_radialGradient33 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "aM",
    cx: 359.74,
    cy: -349.38,
    r: 1,
    gradientTransform: "rotate(51.06 -34314.643 -101561.096) scale(185.71)",
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fffffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#fffef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fffdea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fffbd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fff9c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff48e"
  }))), _radialGradient34 || (_radialGradient34 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "aO",
    cx: 360.54,
    cy: -348.96,
    gradientTransform: "rotate(67.04 -18617.62 -101109.56) scale(227.54)",
    xlinkHref: "#e"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "G",
    x: -15.12,
    y: 78.67,
    width: 40,
    height: 40,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-15.12 99.71 120.93-21 20 114.67-120.92 21Z",
    fill: "url(#d)"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "I",
    x: 3.75,
    y: 96.79,
    width: 116.55,
    height: 144.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 96.8h70.17v65.72H3.77Z",
    fill: "url(#b)"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "K",
    x: 67.43,
    y: 106.63,
    width: 77.74,
    height: 207.3,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.43 106.63h39.23V190H67.43Z",
    fill: "url(#l)"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "P",
    x: 62.75,
    y: 61.85,
    width: 532.31,
    height: 446.35,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.75 86.6 205 61.85l23.47 134.9-142.24 24.76Z",
    fill: "url(#n)"
  })))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "S",
    x: 84.95,
    y: 83.17,
    width: 214.5,
    height: 169.17,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 83.17h82.56v77.33H85Z",
    fill: "url(#p)"
  })))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "V",
    x: 159.67,
    y: 94.75,
    width: 137.38,
    height: 245.86,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.67 94.75h46.15v98.1h-46.15Z",
    fill: "url(#r)"
  })))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "ab",
    x: 152.93,
    y: 41.96,
    width: 858.56,
    height: 540.76,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.93 71.08 320.3 42l27.62 158.71-167.37 29.09Z",
    fill: "url(#t)"
  })))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "ae",
    x: 179.05,
    y: 67.04,
    width: 357.74,
    height: 196.77,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.05 67h97.12v91h-97.12Z",
    fill: "url(#v)"
  })))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "ah",
    x: 266.96,
    y: 80.66,
    width: 224.19,
    height: 293.07,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267 80.66h54.3V196.1H267Z",
    fill: "url(#x)"
  })))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "an",
    x: 260.74,
    y: 19.19,
    width: 1336.33,
    height: 658.58,
    maskUnits: "userSpaceOnUse"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "aq",
    x: 291.46,
    y: 48.7,
    width: 569.75,
    height: 229.22,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.46 48.7h114.27v107H291.46Z",
    fill: "url(#z)"
  })))), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "at",
    x: 395.15,
    y: 64.73,
    width: 352.46,
    height: 350.66,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.15 64.73H459v135.79h-63.85Z",
    fill: "url(#c)"
  })))), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "az",
    x: 388.14,
    y: -8.25,
    width: 2025.2,
    height: 805.34,
    maskUnits: "userSpaceOnUse"
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "aC",
    x: 424.29,
    y: 26.46,
    width: 875.72,
    height: 265.37,
    maskUnits: "userSpaceOnUse"
  })), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "aF",
    x: 546.27,
    y: 45.32,
    width: 536.04,
    height: 420.05,
    maskUnits: "userSpaceOnUse"
  })), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "aL",
    x: 485.7,
    y: -240.96,
    width: 4031.06,
    height: 1669,
    maskUnits: "userSpaceOnUse"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#C)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488.31 274.26h50.5v48.45h45.83v40.13H538.8v78c0 11.56 5.78 16.26 18.05 16.26 7.22 0 13.36-.73 26.35-2.9v49.12c-13.36 3.25-27.07 5.42-39 5.42-33.57 0-55.9-15.9-55.9-57.12V274.26Zm-115.59 0h50.5v48.45h45.83v40.13h-45.84v78c0 11.56 5.77 16.26 18.05 16.26 7.22 0 13.35-.73 26.34-2.9v49.12c-13.35 3.25-27.07 5.42-39 5.42-33.57 0-55.9-15.9-55.9-57.12Zm323.36 43.17c56.14 0 98.06 38.7 98.06 95.67s-41.92 95.67-98.06 95.67S598 470.07 598 413.1s41.93-95.67 98.07-95.67m0 45.28c-28.37 0-50.31 20.08-50.31 50.39s21.94 50.39 50.3 50.39 50.31-20.08 50.31-50.4-21.94-50.38-50.3-50.38m-442.35-45.28c56.14 0 98.07 38.7 98.07 95.67s-41.93 95.67-98.07 95.67-98.07-38.7-98.07-95.67 41.93-95.68 98.07-95.68m0 44.78c-28.65 0-50.81 20.28-50.81 50.9s22.16 50.9 50.8 50.9 50.82-20.29 50.82-50.9-22.16-50.9-50.81-50.9m-176.4-87.94v176.27h67.23v53H24.22V274.26Zm780.74 203a29.16 29.16 0 0 1-26.7 31.43 28.73 28.73 0 0 1-4.73 0 29.16 29.16 0 0 1 0-58.13 28.49 28.49 0 0 1 4.71 0 29.26 29.26 0 0 1 26.7 26.7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#bcbcbb"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.88 197.5c0 2.39-18.45 4.33-41.2 4.33s-41.21-1.94-41.21-4.34 18.45-4.33 41.2-4.33 41.21 1.94 41.21 4.33"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m92.55 58 54.33 128.3L17.5 241.11l-54.34-128.26z",
    fill: "url(#e)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-15.12 99.71 120.93-21 20 114.67-120.92 21Z",
    fill: "url(#f)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#I)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 96.8h70.17v65.72H3.77Z",
    fill: "url(#g)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#K)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.43 106.63h39.23V190H67.43Z",
    fill: "url(#h)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#bcbcbb"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#C)"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.52 201.88c0 2.82-21.7 5.1-48.48 5.1s-48.48-2.28-48.48-5.1 21.7-5.1 48.48-5.1 48.48 2.28 48.48 5.1"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m189.41 37.58 63.93 150.9L101.12 253 37.19 102.06Z",
    fill: "url(#N)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#O)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#P)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.75 86.6 205 61.85l23.47 134.9-142.24 24.76Z",
    fill: "url(#Q)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#S)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 83.17h82.56v77.33H85Z",
    fill: "url(#T)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#U)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#V)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.67 94.75h46.15v98.1h-46.15Z",
    fill: "url(#W)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#bcbcbb"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#C)"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#X)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.18 206.6c0 3.35-25.8 6.06-57.63 6.06s-57.63-2.71-57.63-6.06 25.8-6.06 57.63-6.06 57.63 2.71 57.63 6.06"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Y)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m302 13.4 75.2 177.53-179.13 75.86-75.2-177.52z",
    fill: "url(#Z)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#ab)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.93 71.08 320.3 42l27.62 158.71-167.37 29.09Z",
    fill: "url(#ac)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#ae)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.05 67h97.12v91h-97.12Z",
    fill: "url(#af)"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#ah)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267 80.66h54.3V196.1H267Z",
    fill: "url(#ai)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#bcbcbb"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#C)"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.6 212.2c0 4-30.67 7.2-68.5 7.2s-68.5-3.22-68.5-7.2 30.67-7.2 68.5-7.2 68.5 3.22 68.5 7.2"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m436.05-14.4 88.47 208.85-210.68 89.25-88.48-208.85Z",
    fill: "url(#al)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#an)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m260.74 53.45 196.9-34.26 32.5 186.72-196.91 34.27z",
    fill: "url(#ao)"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#aq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.46 48.7h114.27v107H291.46Z",
    fill: "url(#ar)"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#at)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.15 64.73H459v135.79h-63.85Z",
    fill: "url(#au)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#bcbcbb"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#C)"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M615.35 219.11c0 4.73-36.44 8.56-81.4 8.56s-81.41-3.83-81.41-8.56 36.45-8.56 81.4-8.56 81.41 3.83 81.41 8.56"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m594.4-47.77 104.08 245.7-247.86 105-104.1-245.69Z",
    fill: "url(#ax)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.14 32.06 619.8-8.25 658 211.42l-231.63 40.31Z",
    fill: "url(#aA)"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aB)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#aC)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.3 26.46h134.42V152.4H424.29Z",
    fill: "url(#aD)"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aE)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#aF)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546.27 45.32h75.15v159.75h-75.14Z",
    fill: "url(#aG)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#bcbcbb"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#C)"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aH)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M807.1 227.39c0 5.62-43.3 10.18-96.74 10.18s-96.74-4.56-96.74-10.18 43.32-10.18 96.74-10.18 96.75 4.56 96.75 10.18"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m763.5-95.39 147.77 277.92L633.36 330.3 485.58 52.38Z",
    fill: "url(#aJ)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aK)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#aL)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m711.65-94 182.57 226-226 182.57L485.7 88.6z",
    fill: "url(#aM)"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aN)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m783-86.25 122.46 289.07-291.6 123.53L491.4 37.3z",
    fill: "url(#aO)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.66 159.82V134l-6.52 6-4.76-4.54 12.34-11.26H58v35.62Zm-16.52 7.55H71v2.95H33.14Zm74.15-10v-7c16.47-12.56 21.3-16.8 21.3-21.9 0-3.67-3.2-5.4-6.52-5.4a14.2 14.2 0 0 0-10.8 4.78l-4.88-5.85a20.23 20.23 0 0 1 15.5-6.78c8.63 0 15.39 5 15.39 13.25 0 7.1-5.67 13.25-16.11 21.1h16.41v7.77h-30.29Zm52.56 0v-8.59H140v-7l16.46-25.94h12.17v25.13H174v7.77h-5.34v8.59Zm0-33.65-11.18 17.29h11.18v-17.3Zm-55 42.7h70.3v3.47h-70.3Zm121.8-35.35c0-15.08 8.5-25.75 23.18-25.75a22 22 0 0 1 14.68 5.15l-4.77 8.13a13.19 13.19 0 0 0-9.91-3.88c-7.3 0-12.45 6.2-12.45 14.11a5.3 5.3 0 0 0 .07 1 16.19 16.19 0 0 1 12.75-6.42c8.95 0 17 5.6 17 16.2 0 9.7-7.76 17.1-19.09 17.1-15.13 0-21.46-11.65-21.46-25.69m29.74 9c0-5.23-4.47-7.46-9.17-7.46a12.58 12.58 0 0 0-9.77 4.7c.45 4.78 3.14 10.08 10.07 10.08 5.74 0 8.87-3.89 8.87-7.32m-36.11 25.8h53.82V170h-53.78ZM326 144.56l6.51-8.26a22.69 22.69 0 0 0 15.89 6.6c7 0 10.94-3 10.94-7.39 0-4.6-3.56-6.7-11.64-6.7-2.43 0-6.33.1-7.2.18v-11.13c1 .09 5 .09 7.2.09 6.43 0 10.77-1.92 10.77-6.18 0-4.6-4.78-6.87-10.77-6.87a20.88 20.88 0 0 0-14.76 6l-6.16-7.74c4.69-5.3 12-9.22 22.14-9.22 13.54 0 21.88 6.1 21.88 15.75 0 7.3-6.25 12.08-12.68 13.21 5.9.61 13.55 5.22 13.55 13.92 0 10-8.95 17-22.84 17-10.59 0-18.58-4.09-22.83-9.3m57 8.26 20.75-47.14h-29.2V94.81h43.5v8.61l-21.53 49.4Zm-54 12.3h89.32v4.81H329Zm156.37-15.43v-49.47L474 111.74l-8.27-8.7 21.45-21.59h12.66v68.24Zm26.25-9 8.07-10.13a24.55 24.55 0 0 0 18.09 7.48c8.07 0 12.66-4.6 12.66-10.13 0-6-4.5-10.13-12.25-10.13a19.51 19.51 0 0 0-14.3 5.53l-10.11-2.77V81.45h46.77v12.8h-32.27v16.67a21.55 21.55 0 0 1 15-5.73c11.55 0 21.86 8.29 21.86 22.1 0 14.42-10.83 23.63-27.27 23.63-11.85 0-20.43-3.89-26.25-10.23m-44.5 23.47H577.7v5.67H467.14Zm200.18-17.75V129.8H629v-13.5l31.84-50.19h23.56v48.63h10.3v15h-10.33v16.6H667.3Zm0-65.12-21.63 33.46h21.63Zm32.93 54.52 9.5-11.91a28.86 28.86 0 0 0 21.27 8.78c9.5 0 14.9-5.41 14.9-11.91 0-7.1-5.29-11.92-14.42-11.92a23 23 0 0 0-16.82 6.5l-11.9-3.25v-46h55v15h-38v19.62c3.85-3.85 10.34-6.74 17.67-6.74 13.58 0 25.71 9.75 25.71 26 0 17-12.73 27.8-32.08 27.8-13.94 0-24-4.57-30.88-12m-71.3 27.62H763.6v6.66H628.93Z",
    fill: "#1d1d1b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetherlandsLotto);
export default __webpack_public_path__ + "static/media/netherlands_lotto.787d84b6558093b6fae368f3580c3424.svg";
export { ForwardRef as ReactComponent };